import { CookieStore } from '@switchsystems/aws-amplify-helper';

CookieStore.configure({
  domain: '.coactivecare.co.uk',
  secure: true,
  path: '/',
  expires: 365,
});

const awsconfig = {
  Auth: {
    region: 'eu-west-2',
    userPoolId: 'eu-west-2_ILLuqsBgx',
    userPoolWebClientId: '3hjuijlmquvirki0qoekss28v0',
    authenticationFlowType: 'CUSTOM_AUTH',
  },
  API: {
    endpoints: [
      {
        /* public recruitment frontend uses the recruitment users api
           rather than the usual users api */
        name: 'users',
        endpoint: 'https://recruitment.api.coactivecare.co.uk',
      },
      {
        name: 'recruitment',
        endpoint: 'https://recruitment.api.coactivecare.co.uk',
      },
    ],
  },
  storage: CookieStore,
};

export default awsconfig;
